<template>
  <component
    v-if="component"
    :is="component"
    :is-disabled="disableState"
    :v="v"
    :value="formValue"
    :legend-tag="htmlTag"
    :start-update="updateField"
    v-model="formValue"
    :field="fieldData"/>
</template>

<script>
  export default {
    name: 'form-item',

    props: {
      disableState: { type: Boolean, required: false, default: undefined },
      updateField: { type: Boolean, required: false, default: undefined },
      htmlTag: { type: String, required: false, default: undefined },
      type: { type: String, required: true, default: undefined },
      inputValue: { type: [String, Boolean], required: false, default: undefined },
      data: { type: Object, required: true, default: undefined },
      v: { type: Object, required: false, default: undefined }
    },

    data() {
      return {
        component: null,
        fieldData: this.data
      };
    },

    computed: {
      formValue: {
        get() {
          return this.inputValue;
        },
        set(value) {
          this.$emit('fieldval', { name: this.data.id, value });
        }
      },

      loader() {
        return () => import(`@Feature/CustomForms/fields/Field${this.type.charAt(0).toUpperCase() + this.type.slice(1)}/code/Scripts/components/field-${this.type}.vue`);
      }
    },

    created() {
      this.loader()
        .then(() => {
          this.component = () => this.loader();
        })
        .catch(() => {
          this.component = () => import('@Feature/CustomForms/fields/FieldInput/code/Scripts/components/field-input.vue');
        });
    },
    mounted() {
      this.formValue && this.$emit('fieldval', { name: this.data.id, value: this.formValue });
    }
  };
</script>

<style lang="scss">
</style>
